import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTariffLineItemData extends Layout {
    sourceTariffLineItem: DataSource;
    tableTLIData: Table;
}
